module.exports = __webpack_public_path__ + "static/media/1.4c553b5a.jpg";